/**
 * Regular expression which matches UUID v4's.
 * Regexp from https://stackoverflow.com/questions/7905929/how-to-test-valid-uuid-guid
 */
export const VALID_UUID_REGEXP = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Regular expression which matches UUID v4's without dashes.
 * Regexp adapted from https://stackoverflow.com/questions/7905929/how-to-test-valid-uuid-guid
 */
export const VALID_CLEAN_UUID_REGEXP = /^[0-9a-f]{8}[0-9a-f]{4}[1-5][0-9a-f]{3}[89ab][0-9a-f]{3}[0-9a-f]{12}$/i;
